
angular.
module("dx.webapp.library").
controller("DxLibraryController", function LibraryController(
	$scope
) {
	"use strict";
	var self = this;
	self.showLibrary = true;

	$scope.$watch("vm.showLibrary", function closeLibrary() {
		$scope.$parent.showLibrary = self.showLibrary;
	});

	$scope.$watch("$parent.showLibrary", function updateShowLibrary() {
		self.showLibrary = $scope.$parent.showLibrary;
	});
});
